module.exports = __webpack_public_path__ + "img/watage_res_2.403fc04b.gif";